import React from 'react';
import { Link } from 'react-router-dom';

// The card grid both admin dashboards are built from
export default ({ title, intro, cards }) => (
  <div style={styles.container}>
    <h1>{title}</h1>
    <p>{intro}</p>

    <div style={styles.cardGrid}>
      {cards.map(card => (
        <Link key={card.key} to={card.to} style={styles.cardLink}>
          <div style={styles.card}>
            <h2 style={styles.cardTitle}>{card.title}</h2>
            <p style={styles.cardDescription}>{card.description}</p>
          </div>
        </Link>
      ))}
    </div>
  </div>
);

const styles = {
  container: {
    padding: '20px'
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
    gap: '20px',
    marginTop: '20px'
  },
  cardLink: {
    textDecoration: 'none',
    color: 'inherit'
  },
  card: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '20px',
    height: '100%',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
    transition: 'box-shadow 0.2s ease, transform 0.2s ease',
    cursor: 'pointer',
    backgroundColor: '#fff'
  },
  cardTitle: {
    margin: '0 0 8px 0',
    fontSize: '18px'
  },
  cardDescription: {
    margin: 0,
    color: '#666',
    fontSize: '14px'
  }
};
